import Vue from "vue";
import Vuex from "vuex";

import appointmentModule from "./modules/appointment/appointment-module";
import approvalModule from "./modules/sales/approval-module";
import associatedLabModule from "./modules/associated-lab-module";
import attendanceModule from "./modules/attendance-module";
import authModule from "./modules/auth-module";
import brandModule from "./modules/brand-module";
import broadcastModule from "./modules/broadcast-module";
import cityModule from "./modules/city-module";
import commonModule from "./modules/common-module";
import conversationModule from "./modules/conversation-module";
import countryModule from "./modules/country-module";
import customerModule from "./modules/customer-module";
import doctorModule from "./modules/doctor-module";
import employeeModule from "./modules/employee-module";
import examSampleModule from "./modules/exam-sample-module";
import examSampleScanModule from "./modules/exam-sample-scan-module";
import locationModule from "./modules/location-module";
import manufacturerModule from "./modules/manufacturer-module";
import materialRequestModule from "./modules/material-request-module";
import measurementModule from "./modules/measurement-module";
import medicoAppointmentModule from "./modules/medico/appointment-module";
import medicoProcedureModule from "./modules/medico/procedure-module";
import medicoRoleTussCodeModule from "./modules/medico/rol-tuss-code-module";
import medicoFormCategoryModule from "./modules/medico/form-category-module";
import medicoFormItemModule from "./modules/medico/form-item-module";
import medicalRecordModule from "./modules/medico/medical-record-module";
import approvalQuestionnaireModule from "./modules/medico/approval-questionnaire-module";
import medicoIcdModule from "./modules/medico/icd-module";
import permissionModule from "./modules/permission-module";
import pixTokenModule from "./modules/pix-token-module";
import projectBillingModule from "./modules/sales/billing-module";
import projectLineModule from "./modules/sales/line-module";
import projectModule from "./modules/sales/project-module";
import publicProfileModule from "./modules/public-profile-module";
import roleModule from "./modules/role-module";
import scheduleModule from "./modules/schedule-module";
import serviceModule from "./modules/service-module";
import serviceWorkflowModule from "./modules/service-workflow-module";
import specialtyModule from "./modules/specialty-module";
import stateModule from "./modules/state-module";
import supplyChainCategoryModule from "./modules/supply_chain/category-module";
import supplyChainAccountingCategoryModule from "./modules/supply_chain/accounting-category-module";
import supplyChainItemFusionModule from "./modules/supply_chain/item-fusion-module";
import supplyChainPoInvoiceModule from "./modules/supply_chain/po-invoice-module";
import supplyChainPurchaseOrderModule from "./modules/supply_chain/purchase-order-module";
import supplyChainRawItemChildModule from "./modules/supply_chain/raw-item-child-module";
import supplyChainRawItemMetaModule from "./modules/supply_chain/raw-item-meta-module";
import supplyChainRawItemModule from "./modules/supply_chain/raw-item-module";
import supplyChainRawItemPhotoModule from "./modules/supply_chain/raw-item-photo-module";
import supplyChainRawItemStockModule from "./modules/supply_chain/raw-item-stock-module";
import supplyChainPaymentModule from "./modules/supply_chain/payment-module";
import tagModule from "./modules/globals/tag-module";
import userGroupModule from "./modules/user-group-module";
import userModule from "./modules/user-module";
import workflowSectionModule from "./modules/service-workflow-section-module";
import xmlTemplateColumnModule from "./modules/xml-template-column-module";
import xmlTemplateModule from "./modules/xml-template-module";
import legalCategoryModule from "./modules/legal/category-module";
import leadsModule from "./modules/sales/leads/lead-module";
import petSpeciesModule from "./modules/globals/pet-species-module";
import petBreedsModule from "./modules/globals/pet-breeds-module";
import CategoryModule from "./modules/globals/category-module";
import TaxCategoryModule from "./modules/globals/tax-category-module";
import campaignNotificationModule from "./modules/globals/campaign-notification-module";
import accountReceivableModule from "./modules/finance/account-receivable-module";
import bankAccountModule from "./modules/finance/bank-account-module";
import accountPayableModule from "./modules/finance/account-payable-module";
import freeRegistrationModule from "./modules/free_registration/free-registration-module";
import shareData from "./modules/globals/share_data";
import publicServiceDescriptionModule from "./modules/public-service-description-module";
import qualitySpecificationModule from "./modules/quality/quality-specification-module";
import cashFlowModule from "./modules/finance/cash-flow-module";
import triageModule from "./modules/operational/triage-module";
import vitalSignsModule from "./modules/operational/vital-signs-module";
import chartingByExceptionModule from "./modules/medico/charting-by-exception-module";
import referralsModule from "./modules/medico/referrals-module";
import kanbanModule from "./modules/kanban-module";
import issueModule from "./modules/issue-module";
import employeePrescriptionScheduleModule from "./modules/medico/employee-prescription-schedule-module";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: false,
    modules: {
        appointment: appointmentModule,
        approval: approvalModule,
        associatedLab: associatedLabModule,
        attendance: attendanceModule,
        auth: authModule,
        brand: brandModule,
        broadcast: broadcastModule,
        city: cityModule,
        common: commonModule,
        conversation: conversationModule,
        country: countryModule,
        customer: customerModule,
        doctor: doctorModule,
        employee: employeeModule,
        examSample: examSampleModule,
        examSampleScan: examSampleScanModule,
        location: locationModule,
        manufacturer: manufacturerModule,
        materialRequest: materialRequestModule,
        measurement: measurementModule,
        medicoAppointment: medicoAppointmentModule,
        medicoProcedure: medicoProcedureModule,
        medicoRolTussCode: medicoRoleTussCodeModule,
        medicoFormCategory: medicoFormCategoryModule,
        medicoFormItem: medicoFormItemModule,
        medicalRecord: medicalRecordModule,
        approvalQuestionnaire: approvalQuestionnaireModule,
        medicoIcdModule: medicoIcdModule,
        permission: permissionModule,
        pixToken: pixTokenModule,
        project: projectModule,
        projectBilling: projectBillingModule,
        projectLine: projectLineModule,
        publicProfile: publicProfileModule,
        role: roleModule,
        schedule: scheduleModule,
        service: serviceModule,
        publicServiceDescription: publicServiceDescriptionModule,
        serviceWorkflow: serviceWorkflowModule,
        specialty: specialtyModule,
        state: stateModule,
        supplyChainCategory: supplyChainCategoryModule,
        supplyChainAccountingCategory: supplyChainAccountingCategoryModule,
        supplyChainItemFusion: supplyChainItemFusionModule,
        supplyChainPoInvoice: supplyChainPoInvoiceModule,
        supplyChainPurchaseOrder: supplyChainPurchaseOrderModule,
        supplyChainRawItem: supplyChainRawItemModule,
        supplyChainRawItemChild: supplyChainRawItemChildModule,
        supplyChainRawItemMeta: supplyChainRawItemMetaModule,
        supplyChainRawItemPhoto: supplyChainRawItemPhotoModule,
        supplyChainRawItemStock: supplyChainRawItemStockModule,
        tag: tagModule,
        user: userModule,
        userGroup: userGroupModule,
        workflowSection: workflowSectionModule,
        xmlTemplate: xmlTemplateModule,
        xmlTemplateColumn: xmlTemplateColumnModule,
        legalCategoryModule: legalCategoryModule,
        leadsModule: leadsModule,
        petSpeciesModule: petSpeciesModule,
        petBreedsModule: petBreedsModule,
        category: CategoryModule,
        taxCategory: TaxCategoryModule,
        campaignNotificationModule: campaignNotificationModule,
        accountReceivableModule: accountReceivableModule,
        bankAccountModule: bankAccountModule,
        accountPayableModule: accountPayableModule,
        freeRegistration: freeRegistrationModule,
        shareData: shareData,
        qualitySpecificationModule: qualitySpecificationModule,
        cashFlow: cashFlowModule,
        payment: supplyChainPaymentModule,
        triage: triageModule,
        vitalSigns: vitalSignsModule,
        chartingByException: chartingByExceptionModule,
        referrals: referralsModule,
        kanban: kanbanModule,
        issue: issueModule,
        employeePrescriptionSchedule: employeePrescriptionScheduleModule,
    },
});

export default store;
